import { render, staticRenderFns } from "./UpdateSalaryCommissionContent.vue?vue&type=template&id=119b84b2"
import script from "./UpdateSalaryCommissionContent.vue?vue&type=script&lang=js"
export * from "./UpdateSalaryCommissionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports